// http://121.36.13.81:4067/geoserver/satelliteview/wms?satelliteview:1540952798657-Countries
/* global  Cesium */

import { colorBarToBase64 } from '../Libs/Base64'

/**
 * @description 获取UTS类型图层
 * @param {Object} layerinfo 图层参数
 * @example
 * const UTSLayerParams ={
 *   url:'',
 *   tileSize:512,
 *   colorBar:{},
 *   mapType:'UTSS'
 * }
 */
function getUTSLayer (layerinfo) {
  let oURL = layerinfo.url
  const tileSize = layerinfo.tileSize ? layerinfo.tileSize : 512
  const colorBar = layerinfo.colorBar || {}
  const colorBarStr = colorBarToBase64(colorBar)
  oURL = oURL + '&COLORBAR=' + colorBarStr

  // let url = ' http://121.36.13.81:4500/image?BBOX={westProjected}%2C{southProjected}%2C{eastProjected}%2C{northProjected}&LEVEL={z}&WIDTH=512&HEIGHT=512'
  // url = 'http://10.47.19.89:5000/image?BBOX=-180,22.5,-168.75,33.75&LEVEL=7&WIDTH=512&HEIGHT=512'
  var UTSProvider = new Cesium.UrlTemplateImageryProvider({
    url: oURL,
    tilingScheme: new Cesium.GeographicTilingScheme(),
    tileWidth: tileSize,
    tileHeight: tileSize
  })

  return UTSProvider
}

function getUTSBaseLayer (oURL, tileSize) {
  var UTSProvider = new Cesium.UrlTemplateImageryProvider({
    url: oURL,
    tilingScheme: new Cesium.GeographicTilingScheme(),
    tileWidth: tileSize,
    tileHeight: tileSize
  })
  return UTSProvider
}

function getUTTSLayer (layerinfo, isXYZ) {
  const tileSize = layerinfo.tileSize ? layerinfo.tileSize[0] : 512
  // 基础数据类型
  const serverType = layerinfo.mapType ? layerinfo.mapType : 'UTTS'
  // 产品 参数
  const prodParams = layerinfo.params
  const PRODUCT = prodParams.PRODUCT
  const STARTTIME = prodParams.STARTTIME
  const ENDTIME = prodParams.ENDTIME
  const COLORBAR = prodParams.COLORBAR
  const FORMAT = prodParams.FORMAT || 'image/png'
  const COLORBARSTR = colorBarToBase64(COLORBAR)

  // 重新拼接 params
  const urlParams = {
    url: layerinfo.url,
    serverType: serverType,
    prodParams: prodParams,
    PRODUCT: PRODUCT,
    STARTTIME: STARTTIME,
    ENDTIME: ENDTIME,
    COLORBARSTR: COLORBARSTR,
    tileSize: tileSize,
    FORMAT: FORMAT
  }
  const matchUrl = getUrlByParam(urlParams, isXYZ)
  const UTSProvider = getUTSBaseLayer(matchUrl, tileSize)
  return UTSProvider
}
function getUrlByParam (urlParams, isXYZ) {
  let url = urlParams.url

  // 类型一定要有
  if (urlParams.serverType) {
    url = url + 'SERVICE=' + urlParams.serverType
  }
  // ;('&VERSION=1.3.0&FORMAT=image%2Fpng')
  // 产品名称
  if (urlParams.PRODUCT) {
    url = url + '&PRODUCT=' + urlParams.PRODUCT
  }
  // 开始时间
  if (urlParams.STARTTIME) {
    url = url + '&STARTTIME=' + urlParams.STARTTIME
  }
  // 结束时间
  if (urlParams.ENDTIME) {
    url = url + '&ENDTIME=' + urlParams.ENDTIME
  }
  // 宽高
  if (urlParams.tileSize) {
    url = url + '&WIDTH=' + urlParams.tileSize + '&HEIGHT=' + urlParams.tileSize
  }

  url = url + '&CRS=EPSG%3A4326'

  if (isXYZ === 'XYZ') {
    url = url + '&X={x}&Y={y}&LEVEL={z}'
    url = url +
      '&BBOX={westProjected}%2C{southProjected}%2C{eastProjected}%2C{northProjected}'
  } else {
    url = url +
      '&BBOX={westProjected}%2C{southProjected}%2C{eastProjected}%2C{northProjected}&LEVEL={z}'
  }
  // 调色板
  if (urlParams.COLORBARSTR !== '') {
    url = url + '&COLORBAR=' + urlParams.COLORBARSTR
  }
  if (urlParams.FORMAT) {
    url = url + '&FORMAT=' + urlParams.FORMAT
  }
  // let url = `http://121.36.13.81:4550/image?SERVICE=${serverType}
  // &FORMAT=${FORMAT}
  // &PRODUCT=${PRODUCT}
  // &STARTTIME=${STARTTIME}
  // &ENDTIME=${ENDTIME}&CRS=EPSG:4326
  // &BBOX={westProjected}%2C{southProjected}%2C{eastProjected}%2C{northProjected}
  // &LEVEL={z}&WIDTH=${tileSize}&HEIGHT=${tileSize}&COLORBAR=${COLORBARSTR}`

  return url
}

export { getUTSLayer, getUTTSLayer, getUTTSLayer as getUTSSLayer }
